export default __webpack_public_path__ + "static/media/construction.b99470dc.svg";